import(/* webpackMode: "eager" */ "C:\\Users\\sunk_\\Downloads\\typhoon\\typhoon-rocket-update\\typhoon-rocket-update\\src\\app\\alerts\\page.tsx");
